import React, { useEffect, useMemo } from 'react';
import { useDimension } from 'lb-components';

import ModalWeb from './web/GameDepositModal';
import ModalMob from './mob/GameDepositModal';

export const GameDepositModal = ({
  platform,
  onCancel,
  onSuccess,
  ...props
}) => {
  /*const { size } = useDimension();
  const currPlatform = useMemo(() => {
    return ['chitovic', 'md'].indexOf(size) > -1 ? 'mob' : 'web';
  }, [size]);
  useEffect(() => {
    if (currPlatform !== platform) {
      onCancel();
    }
  }, [currPlatform]);*/

  /*return <ModalMob onCancel={onCancel} onSuccess={onSuccess} {...props} />;*/
  return platform === 'web' ? (
    <ModalWeb onCancel={onCancel} onSuccess={onSuccess} {...props} />
  ) : (
    <ModalMob onCancel={onCancel} onSuccess={onSuccess} {...props} />
  );
};
